__turbopack_context__.v({
  "breadcrumbs": "-NkYpa_breadcrumbs",
  "introDescription": "-NkYpa_introDescription",
  "introHeadline": "-NkYpa_introHeadline",
  "magazineAuthor": "-NkYpa_magazineAuthor",
  "pageTitle": "-NkYpa_pageTitle",
  "profileImage": "-NkYpa_profileImage",
  "subTitle": "-NkYpa_subTitle",
  "title": "-NkYpa_title",
});
